import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import SoundAssetKeys from '../SoundAssetKeys';
import FontKeys from '../FontKeys';

const MenuButtons = [];

export default class MenuButton extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, sprite)
    {
        super(scene, 0, 0);

        MenuButtons.push(this);

        this.bg = ABCyaPhaser.Images.addImage(0,0,sprite, this).setOrigin(0);
        this.setSize(this.bg.width, this.bg.height);
        ABCyaPhaser.Container.setContainerInteractive(this);

        this.text = ABCyaPhaser.Text.addText(111,this.bg.height/2,16, 0xffffff, FontKeys._BPreplayBold, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen." + sprite), this).setWordWrapWidth(100).setResolution(2);

        ABCyaPhaser.Container.makeContainerTintable(this);
        ABCyaPhaser.Buttons.convertToButton(this, {});

        this.isHighlighted = false;

        this.name = sprite;

        this.on(ABCyaPhaser.Buttons.Events.ButtonEvents.CLICK,this.doClick, this);
    }

    doClick()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

        if (!this.isHighlighted)
        {
            MenuButton.highlightOff();
            this.highlightOn();
        }
        else
        {
            this.highlightOff();
        }
    }

    highlightOn()
    {
        this.emit("SELECTED", this);
        this.isHighlighted = true;
        this.overlay = this.scene.add.rectangle(this.x, this.y, this.width, this.height, 0xffffff, 0.4).setOrigin(0);
        this.scene.add.existing(this.overlay);
    }

    highlightOff()
    {
        this.isHighlighted = false;
        this.overlay.destroy();

        this.emit("UNSELECTED", this);
    }

    static highlightOff()
    {
        let len = MenuButtons.length;
        for (let i = 0; i < len; i++)
        {
            let thisOne = MenuButtons[i];

            if (thisOne.isHighlighted)
            {
                thisOne.highlightOff();
            }
        }
    }
}